<template>
  <generic-container
    icon="snowflake"
    :title="$t('cooldown')"
    :configurable="false"
    :show_plus="true"
    v-bind:configure_modal="configure_modal"
    @add="add"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
    v-if="!has_argument"
  >
    <div class="ui three link cards">
      <div
        class="card"
        v-for="(exhibit, eidx) in exhibits"
        :key="eidx"
        @click="select_exhibit(exhibit)"
      >
        <div class="content">
          <div class="header">{{ exhibit.name }}</div>
          <div class="meta">{{ exhibit.code }}</div>
          <div class="description">
            {{ exhibit.description }}
          </div>
        </div>
      </div>
    </div>
    <exhibit-modal ref="exhibit_modal" @success="init" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import { local_api, enterprise_setup, error_toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import ExhibitModal from "./exhibit_modal/Index.vue";
// import LinkReviewModal from "./link_review_modal/Index.vue";
// import { quotas } from "./quotas.js";

// @ is an alias to /src
export default {
  name: "CooldownIndex",
  components: {
    "generic-container": GenericContainer,
    ExhibitModal,
    // LinkReviewModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      header_buttons: [
        // {
        //   icon: "cubes",
        //   click: this.go_bulk,
        //   tooltip: this.$t("bulk process"),
        // },
      ],
      exhibits: [],
      has_argument: false,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.exhibit_modal.show_modal();
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/cooldown/exhibit/do-get-list", {})
        .then((list) => {
          vm.exhibits = list;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    select_exhibit(exhibit) {
      let vm = this;
      vm.$refs.exhibit_modal.show_modal(exhibit);
    },
  },
  created() {},
  mounted() {
    let vm = this;

    let arg = vm.$route.query.p;
    if (arg) {
      vm.has_argument = true;
      /** Register visit */
      local_api(vm, "post", "/cooldown/visit/do-register", {
        c: arg,
      })
        .then(() => {
          vm.$router.replace({ name: "CooldownRegister", query: { p: arg } });
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      vm.init();
    }
  },
  watch: {},
};
</script>
